<template>
  <div id="app">
	<div v-if="!ie_status" class="app-content">
		<lg-header class="header-position"></lg-header>
		<router-view class="router-view" :style="{minHeight:minHeight+'px',}" v-if="isRouterAlive"/>
		<lg-footer class="footer-position"></lg-footer>
		<lg-login v-if="this.$store.state.status.login"/>
		<lg-interest />
		<lg-tips></lg-tips>
		<el-backtop :visibility-height="100"></el-backtop>
	</div>
	<compatible v-else></compatible>
	  <audio controls ref="audioRef" style="display: none">
		  <source :src="fileurl" type="audio/mpeg"/>
	  </audio>
  </div>
</template>

<script>
  import Footer from './components/footer'
  import Header from './components/header'
  import login from './components/login'
  import tips from './pages/tips'
  import compatible from "./pages/compatible";
  import interest from './components/interest/index'
  import {mapMutations} from "vuex";
  export default {
  components: {
    'lg-header':Header,
    'lg-footer':Footer,
    'lg-login':login,
    'lg-tips':tips,
    'lg-interest':interest,
    compatible
  },
  name: 'App',
  provide (){
      return {
        reload:this.reload
      }
  },
  data(){
    return {
      isRouterAlive:true,
      minHeight:0,
      ie_status:false,
      fileurl:"https://zhugecoming-resource.oss-cn-chengdu.aliyuncs.com/message_sound.wav"
    }
  },
  methods:{
    ...mapMutations(['webInfo']),
    reload (){
      this.isRouterAlive = false
      this.$nextTick(function(){
          this.isRouterAlive = true
      })
    },
    handleGetInfo(){
      this.$requestApi.index.webInfo().then(res => {
        this.webInfo(res.data)
        document.querySelector('meta[name="description"]').setAttribute('content', this.getSettingConfig.getInfo('seo'))
        document.querySelector('meta[name="keywords"]').setAttribute('content', this.getSettingConfig.getInfo('seo'))
        document.title = this.getSettingConfig.getInfo('app_name') === null ? "诸葛来了" : this.getSettingConfig.getInfo('app_name')
      })
    },
    IEVersion(){
      !!window.ActiveXObject || "ActiveXObject" in window ? this.ie_status =true:this.ie_status =false
    },
  },
  mounted() {
    if (!this.ie_status){
      const that = this
      const height = document.querySelector('.footer-position')
      const height2 = document.querySelector('.header')
      this.minHeight = document.documentElement.clientHeight-height.clientHeight-height2.clientHeight+1
      window.onresize = function () {
        that.minHeight = document.documentElement.clientHeight-height.clientHeight-height2.clientHeight+1
      }
    }
    this.$Bus.$off('play_audio').$on("play_audio",value => {
      let recordAudio = this.$refs.audioRef; //获取audio元素
      recordAudio.play();
    })
  },
  created() {
    this.IEVersion()
    this.handleGetInfo()
    if(navigator.userAgent.match(/(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i)) {
      let path_form={
        name:window.location.pathname,
        id:window.location.search.substr(window.location.search.indexOf('=')+1)
      }
      localStorage.setItem('path_info',JSON.stringify(path_form))
      this.$router.push('wx_url')
    }
  },
}
</script>

<style>
#app {
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  position:absolute;
  box-sizing: border-box;
}
.app-content{
	padding-top: 47px;
	background-color: #F4F4F4;
}
.router-view{
	background-color: #F4F4F4;
	position: relative;
}
::-webkit-scrollbar {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue